/**
 * The name a meditation's sound is published under in a call.
 *
 * It is played to the patient rather than said by anyone in the session, so a
 * session recorded track by track leaves it out of the clinical record. The
 * backend recognises it by this exact name (`MEDITATION_TRACK_NAME` in
 * `meeting_tracks.py`); the two must change together.
 */
export const MEDITATION_TRACK_NAME = "meditation";
